import React from 'react';

const BreweryIcon = (props) => {
  return (
    <img
      alt="Browar"
      src="/static/images/icons/place_types/brewery.svg"
      {...props}
    />
  );
};

export default BreweryIcon;
